import { SxProp, Pressable, View, Text } from 'dripsy';
import React from 'react';
import * as Clipboard from 'expo-clipboard';
import { Icon } from '../icons/Icon';

export interface UniIconCardProps {
  icon: string;
  options?: {
    height: number;
    width: number;
  };
}

export const UniIconCard: React.FC<UniIconCardProps> = (props) => {
  const { icon, options } = props;

  const onPress = async () => {
    await Clipboard.setStringAsync(icon);
  };

  return (
    <Pressable onPress={onPress}>
      {({ pressed }) => (
        <View sx={pressed ? sxStyles.containerPressed : sxStyles.container}>
          <View sx={sxStyles.iconContainer}>
            <Icon name={icon} height={50} width={50} />
          </View>
          <Text variant="labelText" sx={sxStyles.iconText}>
            {icon}
          </Text>
        </View>
      )}
    </Pressable>
  );
};

const sxStyles: Record<string, SxProp> = {
  container: {
    width: 100,
    height: 'auto',
    mb: '$3',
    borderWidth: 1,
    borderStyle: 'solid',
    borderRadius: 3,
    borderColor: '$borderPrimary',
    alignItems: 'center'
  },
  containerPressed: {
    width: 100,
    height: 'auto',
    mb: '$3',
    borderWidth: 1,
    borderStyle: 'solid',
    borderRadius: 5,
    borderColor: '$borderPrimary',
    backgroundColor: '$backgroundSecondary',
    alignItems: 'center'
  },
  iconContainer: {
    width: 100,
    height: 70,
    justifyContent: 'center',
    alignItems: 'center'
  },
  iconText: {
    mb: '$2',
    fontSize: 9
  }
};
